// extracted by mini-css-extract-plugin
export default {"cafonata":"RotatingBadge_cafonata_EtnX8","dark":"RotatingBadge_dark_hR1oT","white":"RotatingBadge_white_rTT69"};